import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { UserFragmentDoc } from '../../../../../../../../../graphql/fragments/generated/User';
import { SkillPillFragmentDoc } from '../../../../../../../../events/graphql/fragments/generated/SkillPill';
export type AddQuestionListItemFragment = { id: string, questionText?: string | null, questionType: Types.QuestionTypeEnum, subType?: Types.QuestionSubTypeEnum | null, createdBy?: { id: string, name?: string | null, firstName?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null } | null, skills: Array<{ id: string, name: string }> };


export type AddQuestionListItemFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const AddQuestionListItemFragmentDoc = /*#__PURE__*/ gql`
    fragment AddQuestionListItem on QuestionType {
  id
  questionText
  questionType
  subType
  createdBy {
    ...User
  }
  skills {
    ...SkillPill
  }
}
    `;